var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { runtime } from '../../../../../classes/runtime/Runtime';
let RareInputMaskRender = class RareInputMaskRender extends React.PureComponent {
    render() {
        const { aspect, jsxAttributes, renderRef, renderProps } = this.props;
        const { onChange } = renderProps;
        const onChangeWrapper = action(e => {
            if (aspect.context.memorizePointsWordTask && !aspect.context.questionMemorizePoints.isOrdered) {
                const question = aspect.parent.parent;
                question.memorizePointsRemaining.remainingWordTasks.forEach(wordTask => {
                    wordTask.wordTaskInput.inputValueHidden = e.target.value;
                });
                const bestMatching = question.memorizePointsUnordered.bestMatchingRemainingWordtask;
                onChange(e);
                bestMatching.wordTaskForm.focusInputField();
                return;
            }
            if (onChange)
                onChange(e);
        });
        const onBlurWrapper = action(e => {
            if (aspect.context.memorizePointsWordTask && !aspect.context.questionMemorizePoints.isOrdered) {
                return;
            }
            if (onChange)
                onChange(e);
        });
        const onKeyUpWrapper = action(e => {
            // console.log('onKeyUp', e);
        });
        const { value, ...pass } = jsxAttributes;
        const refWrapper = (e) => {
            runtime.runtimeScheduler.scheduleForAnimationFrame(() => aspect.aspectMount.setDomNode(e));
            renderRef(e);
        };
        return React.createElement("input", { ...pass, ref: refWrapper, ...renderProps, onChange: onChangeWrapper, onBlur: onBlurWrapper, onKeyUp: onKeyUpWrapper });
    }
};
RareInputMaskRender = __decorate([
    observer
], RareInputMaskRender);
export { RareInputMaskRender };
